import axiosInstance from '../axiosConfig';

export const focusAreaService = {
    // Initialize CSRF token (call this when app loads)
    async initializeCsrf() {
        try {
            await axiosInstance.get('/sanctum/csrf-cookie');
            console.log('CSRF token initialized');
        } catch (error) {
            console.error('Failed to initialize CSRF token:', error);
        }
    },

    async getAll(params?: { page?: number; per_page?: number; search?: string }) {
        const response = await axiosInstance.get('/api/admin/focus-areas', { params });
        return response.data;
    },

    async getById(id: number) {
        const response = await axiosInstance.get(`/api/admin/focus-areas/${id}`);
        return response.data;
    },

    async create(formData: FormData) {
        const response = await axiosInstance.post('/api/admin/focus-areas', formData);
        return response.data;
    },

    async update(id: number, formData: FormData) {
        const response = await axiosInstance.post(`/api/admin/focus-areas/${id}`, formData);
        return response.data;
    },

    async delete(id: number) {
        const response = await axiosInstance.delete(`/api/admin/focus-areas/${id}`);
        return response.data;
    },

    async bulkDelete(ids: number[]) {
        const response = await axiosInstance.post('/api/admin/focus-areas/bulk-delete', { ids });
        return response.data;
    },

    async updateStatus(id: number, isActive: boolean) {
        const response = await axiosInstance.patch(`/api/admin/focus-areas/${id}/status`, {
            is_active: isActive
        });
        return response.data;
    }
};





















// import axiosInstance from './axiosConfig';

// export const focusAreaService = {
//     // Initialize CSRF token (call this when app loads)
//     async initializeCsrf() {
//         try {
//             await axiosInstance.get('/sanctum/csrf-cookie');
//             console.log('CSRF token initialized');
//         } catch (error) {
//             console.error('Failed to initialize CSRF token:', error);
//         }
//     },

//     async getAll() {
//         const response = await axiosInstance.get('/api/admin/focus-areas');
//         return response.data;
//     },

//     async getById(id: number) {
//         const response = await axiosInstance.get(`/api/admin/focus-areas/${id}`);
//         return response.data;
//     },

//     async create(formData: FormData) {
//         const response = await axiosInstance.post('/api/admin/focus-areas', formData);
//         return response.data;
//     },

//     async update(id: number, formData: FormData) {
//         const response = await axiosInstance.post(`/api/admin/focus-areas/${id}`, formData);
//         return response.data;
//     },

//     async delete(id: number) {
//         const response = await axiosInstance.delete(`/api/admin/focus-areas/${id}`);
//         return response.data;
//     },

//     async updateStatus(id: number, isActive: boolean) {
//         const response = await axiosInstance.patch(`/api/admin/focus-areas/${id}/status`, {
//             is_active: isActive
//         });
//         return response.data;
//     }
// };